<script>
    import {Line, mixins} from 'vue-chartjs';

    const {reactiveProp} = mixins;

    export default {
        name: "chart",
        extends: Line,
        mixins: [reactiveProp],
        props: ['options'],
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        },
        mounted() {
            this.renderChart(this.chartData, this.options)
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/layout/LineChart.vue